import { Dispatch } from "redux";
import { baseAction } from "./baseAction";
import { opportunityConstant } from "../constants";
import { opportunityService } from "../services/opportunityService";
import type {
  CreateOpportunityRequest,
  UpdateOpportunityRequest,
  UpdateOpportunityOrderRequest,
  OpportunityFilters,
} from "../services/opportunityService";

const { request, success, failure } = baseAction;

// Get opportunities by pipeline with optional filters
const getOpportunitiesByPipeline = (
  pipelineId: number, 
  filters?: OpportunityFilters,
  cb: (data?: any) => void = () => {}
) => {
  return (dispatch: Dispatch) => {
    dispatch(request(opportunityConstant.GET_OPPORTUNITIES_BY_PIPELINE_R, { pipelineId, filters }));
    
    opportunityService.getOpportunitiesByPipeline(pipelineId, filters).then(
      (data) => {
        dispatch(success(opportunityConstant.GET_OPPORTUNITIES_BY_PIPELINE_S, data));
        cb(data);
      },
      (error) => {
        dispatch(failure(opportunityConstant.GET_OPPORTUNITIES_BY_PIPELINE_F, error));

      }
    );
  };
};

// Get opportunities by stage
const getOpportunitiesByStage = (stageId: number, cb: (data?: any) => void = () => {}) => {
  return (dispatch: Dispatch) => {
    dispatch(request(opportunityConstant.GET_OPPORTUNITIES_BY_STAGE_R, { stageId }));
    
    opportunityService.getOpportunitiesByStage(stageId).then(
      (data) => {
        dispatch(success(opportunityConstant.GET_OPPORTUNITIES_BY_STAGE_S, data));
        cb(data);
      },
      (error) => {
        dispatch(failure(opportunityConstant.GET_OPPORTUNITIES_BY_STAGE_F, error));

      }
    );
  };
};

// Get single opportunity
const getOpportunity = (id: number, cb: (data?: any) => void = () => {}) => {
  return (dispatch: Dispatch) => {
    dispatch(request(opportunityConstant.GET_OPPORTUNITY_R, { id }));
    
    opportunityService.getOpportunity(id).then(
      (data) => {
        dispatch(success(opportunityConstant.GET_OPPORTUNITY_S, data));
        cb(data);
      },
      (error) => {
        dispatch(failure(opportunityConstant.GET_OPPORTUNITY_F, error));

      }
    );
  };
};

// Create opportunity
const createOpportunity = (params: CreateOpportunityRequest, cb: (data?: any) => void = () => {}) => {
  return (dispatch: Dispatch) => {
    dispatch(request(opportunityConstant.CREATE_OPPORTUNITY_R, params));
    
    opportunityService.createOpportunity(params).then(
      (data) => {
        dispatch(success(opportunityConstant.CREATE_OPPORTUNITY_S, data));

        cb(data);
      },
      (error) => {
        dispatch(failure(opportunityConstant.CREATE_OPPORTUNITY_F, error));

      }
    );
  };
};

// Update opportunity
const updateOpportunity = (id: number, params: UpdateOpportunityRequest, cb: (data?: any) => void = () => {}) => {
  return (dispatch: Dispatch) => {
    dispatch(request(opportunityConstant.UPDATE_OPPORTUNITY_R, { id, ...params }));
    
    opportunityService.updateOpportunity(id, params).then(
      (data) => {
        dispatch(success(opportunityConstant.UPDATE_OPPORTUNITY_S, data));

        cb(data);
      },
      (error) => {
        dispatch(failure(opportunityConstant.UPDATE_OPPORTUNITY_F, error));

      }
    );
  };
};

// Delete opportunity
const deleteOpportunity = (id: number, cb: (data?: any) => void = () => {}) => {
  return (dispatch: Dispatch) => {
    dispatch(request(opportunityConstant.DELETE_OPPORTUNITY_R, { id }));
    
    opportunityService.deleteOpportunity(id).then(
      (data) => {
        dispatch(success(opportunityConstant.DELETE_OPPORTUNITY_S, { id }));

        cb(data);
      },
      (error) => {
        dispatch(failure(opportunityConstant.DELETE_OPPORTUNITY_F, error));

      }
    );
  };
};

// Update opportunity order (for drag & drop)
const updateOpportunityOrder = (id: number, params: UpdateOpportunityOrderRequest, cb: (data?: any) => void = () => {}) => {
  return (dispatch: Dispatch) => {
    dispatch(request(opportunityConstant.UPDATE_OPPORTUNITY_ORDER_R, { id, ...params }));
    
    opportunityService.updateOpportunityOrder(id, params).then(
      (data) => {
        dispatch(success(opportunityConstant.UPDATE_OPPORTUNITY_ORDER_S, data));
        cb(data);
      },
      (error) => {
        dispatch(failure(opportunityConstant.UPDATE_OPPORTUNITY_ORDER_F, error));

      }
    );
  };
};

// Clear opportunities state
const clearOpportunitiesState = () => {
  return (dispatch: Dispatch) => {
    dispatch(success(opportunityConstant.CLEAR_OPPORTUNITIES_STATE, null));
  };
};

export const opportunityAction = {
  getOpportunitiesByPipeline,
  getOpportunitiesByStage,
  getOpportunity,
  createOpportunity,
  updateOpportunity,
  deleteOpportunity,
  updateOpportunityOrder,
  clearOpportunitiesState,
};
